import Vue from 'vue'
import {ProgressReportOld, Quote} from "@models";

export const progressReportStore = {
    state: Vue.observable({
        items: [],
        quotes: [],
        lastCompleted: [],
    }),
    lastLoaded: false,

    async init(packageId) {
        if (packageId !== this.lastLoaded) {
            const {data} = await Http.get(route('api.v1.package.progress-reports.index', packageId))
            this.state.quotes = data.quotes.map((item) => Quote.make(item));
            this.state.items = data.progress.map((item) => ProgressReportOld.make(item));
            this.lastLoaded = packageId;
            this.rebuildLastCompleted()
        }
    },

    async update(item, attributes = {}) {
        const url = route('api.v1.package.progress-reports.update', item.id)
        const payload = ProgressReportOld.parseAttributes({...item.getFormAttributes(), ...attributes})
        const {data} = await Http.put(url, payload)
        this.updateProgressStore(data);
        return item;
    },

    async create(attributes = {}, packageId) {
        const url = route('api.v1.package.progress-reports.create', packageId)
        const payload = ProgressReportOld.parseAttributes({...attributes})
        const {data} = await Http.post(url, payload)
        const id = this.updateProgressStore(data);
        return this.state.items.find((item) => id === item.id);
        ;
    },

    async deleteItem(item) {
        const url = route('api.v1.package.progress-reports.destroy', item.id)
        const {data} = await Http.delete(url, {})
        this.state.items = this.state.items.filter((i) => i.id !== item.id);
        this.updateProgressStore(data);
    },

    updateProgressStore(data) {
        let added = false;
        data.progress.forEach((i) => {
            let existingItem = this.state.items.find((item) => i.id === item.id);
            if (existingItem) {
                existingItem.setAttributes(i)
            } else {
                let newItem = ProgressReportOld.make(i);
                added = newItem.id;
                this.state.items.unshift(newItem);
            }
        })
        this.rebuildLastCompleted()
        return added;
    },

    rebuildLastCompleted() {
        let lastData = [];
        this.state.items.forEach((pr) => {
            pr.submitted_item_values.forEach((q) => {
                if (parseFloat(q.percent) === 100) {
                    let key= 'Quote'+q.quote_id+'|Task'+q.task_id+'|Item'+q.item_id;
                    lastData[key] = pr
                }
            })
            pr.submitted_preliminary_values.forEach((q) => {
                if (parseFloat(q.percent) === 100) {
                    let key= 'Quote'+q.quote_id+'|Prelim'+q.preliminary_id;
                    lastData[key] = pr
                }
            })
        })
        this.state.lastCompleted = lastData;
    }
}